import React, { createRef } from "react";
import {
  Input,
  Select,
  Checkbox,
  Row,
  Col,
  Button,
  Space,
  DatePicker,
  Dropdown,
  Modal,
  Image,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import MileageReportStore from "../store/MileageReportStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import VehicleStore from "../store/VehicleStore";
import dayjs from "dayjs";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import withRouter from "../withRouter";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import PythonMessageAlert from "./PythonMessageAlert";

const { RangePicker } = DatePicker;

const { Option } = Select;
class MileageReportList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.mileageReportStore = new MileageReportStore();
    this.vehicleStore = new VehicleStore();
    this.pythonMessageRef = createRef();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      selectedVehicles: [],
      selectAllVehicles: false,
      companyId: "",
      modalVisible: false,
      column: "",
      filter: "",
      pageNo: 1,
      loadData: 0,
      showMonthPopup: false,
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      Notcompany: false,
      Notasset: false,
      Notdate: false,
      notFilter: false,
      reportmessage: "",
      selectedColumns: [
        {
          // title: "Asset Name",
          title: context.translate("_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Driver",
          title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"),
          dataIndex: "driverName",
          key: "driver",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Start Odometer",
          title: context.translate("_FLEET_REPORTS_DISTANCEREPORT_STARTOD_"),
          dataIndex: "startDistance",
          key: "startDistance",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Stop Odometer",
          title: context.translate("_FLEET_REPORTS_DISTANCEREPORT_STOPOD_"),
          dataIndex: "stopDistance",
          key: "stopDistance",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Start Date/Time",
          title: context.translate(
            "_FLEET_REPORTS_STARTSTOPREPORT_STARTDATETIME_"
          ),
          dataIndex: "startTime",
          key: "startTime",
          ellipsis: {
            showTitle: true,
          },
          render: (value) => {
            if (value) {
              const formattedDateTime = dayjs(value).format(
                "DD-MM-YYYY hh:mm:ss A"
              );
              return <>{formattedDateTime}</>;
            } else {
              return <></>;
            }
          },
        },
        {
          // title: "Stop Date/Time",
          title: context.translate(
            "_FLEET_REPORTS_STARTSTOPREPORT_STOPDATETIME_"
          ),
          dataIndex: "stopTime",
          key: "stopTime",
          ellipsis: {
            showTitle: true,
          },
          render: (value) => {
            if (value) {
              const formattedDateTime = dayjs(value).format(
                "DD-MM-YYYY hh:mm:ss A"
              );
              return <>{formattedDateTime}</>;
            } else {
              return <></>;
            }
          },
        },

        {
          // title: "Distance Travelled",
          title: context.translate(
            "_FLEET_REPORTS_STARTSTOPREPORT_DISTTRAVEL_"
          ),
          dataIndex: "distanceTravelled",
          key: "distanceTravelled",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: " Fuel Consumption",
          title: context.translate("_FUEL_CONSUMPTION_"),
          dataIndex: "fuelconsumption",
          key: "fuelconsumption",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "  Cost",
          title: context.translate("_COST_"),
          dataIndex: "cost",
          key: "cost",
          ellipsis: {
            showTitle: true,
          },

          //   fixed: 'right',
        },
      ],
    };
    this.ExportMenuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: async (val) => {
        let result = [];
        console.log(val);
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          //  console.log(result.toString())

          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            // interval: this.state.interval,
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            fuelprice: this.state.fuelprice,
            mileage: this.state.mileage,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            colList: result.toString(),
            filterValue: this.state.filterValue,
          };
          if (val.key == "excel") {
            await this.mileageReportStore.exportExcel(getData);
            const isSuccess =
              this.mileageReportStore?.pythonReportMessage === true;
            const isError = this.mileageReportStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
          if (val.key == "pdf") {
            await this.mileageReportStore.exportpdf(getData);
            const isSuccess =
              this.mileageReportStore?.pythonReportMessage === true;
            const isError = this.mileageReportStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
          if (val.key == "csv") {
            this.mileageReportStore.exportcsv(getData);
          }
          if (val.key == "xml") {
            this.mileageReportStore.exportxml(getData);
          }
        }
      },
    };

    this.newColumns = [...this.state.selectedColumns];
  }
  async componentDidMount() {
    // await this.mileageReportStore.loadData({ offset: 0, limit: 50 });

    // this.setState({ pageSize: 10 });
    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }

    await this.setState({ column: this.state.selectedColumns });
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({ companyId: comp?.value });
    await this.setState({ selectedVehicles: [], selectAllVehicles: false });
    await this.vehicleStore.getVehiclesCompanyId(comp?.value);

    await this.handleSearch();
    //  console.log(data,"sdcd")
  }

  async handleSearch() {
    this.setState({ Notasset: false, pageNo: 1 });
    // await this.mileageReportStore.loadData({
    //   offset: (this.state.pageNo - 1) * this.state.pageSize,
    //   limit: this.state.pageSize,
    //   companyId: this.state.companyId,
    //   pageNo: this.state.pageNo,
    //   vehicleId: this.state.selectedVehicles,
    // });
    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      // currentPage: pagination.current,
      pageNo: pagination.current,
      pageSize: pagination.pageSize,
    });
    // this.handleSearch();
    await this.showData();
  }

  // vehicleSelect = async (val) => {
  //   console.log(val);
  //   await this.setState({ selectedVehicles: val });
  // };

  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (!this.state.fromDate) {
      this.setState({ Notdate: true });
    } else {
      this.setState({ Notdate: false });
    }
    if (!this.state.filterValue) {
      this.setState({ notFilter: true });
    } else {
      this.setState({ notFilter: false });
    }

    if (
      this.state.companyId &&
      this.state.selectedVehicles.length > 0 &&
      this.state.fromDate &&
      this.state.toDate &&
      this.state.filterValue
    ) {
      // this.setState({mandatory:false})
      this.setState({ Notcompany: false, Notasset: false });
      if (this.checkFromDate(this.state.fromdateStdTime)) {
        await this.mileageReportStore.loadData({
          offset: (this.state.pageNo - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          vehicleId: this.state.selectedVehicles,
          fuelprice: this.state.fuelprice,
          mileage: this.state.mileage,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          filterValue: this.state.filterValue,
          pageNo: this.state.pageNo,
        });
        await this.setState({ loadData: 1 });
      }
    }
  };

  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };

  addMonths = (date, months) => {
    // date.setMonth(date.getMonth() + months);
    // date = date + months;
    var indx = dayjs().month() + -6;
    // return date.format("YYYY-MM-DD HH:mm:ss");
    return dayjs().month(indx);
  };
  checkFromDate(dates) {
    //  var fromDate = dates.format("YYYY-MM-DD HH:mm:ss");
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      //  Ext.Msg.show({
      //      title: fleet.Language.get('_FLEET_ALERT_'),
      //      msg: fleet.Language.get('_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_'),
      //      buttons: Ext.Msg.OK,
      //  });
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }
  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    } else {
      this.setState({ fromDate: "", toDate: "" });
    }
  };

  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };
  refreshList = async () => {
    await this.setState({ loading: false, current: 1, currentPage: 1 });
    await this.showData();
  };

  triggerReport = () => {
    this.pythonMessageRef.current.show(); // show the modal
  };

  render() {
    const companyInputStyle = this.state.Notcompany
      ? { border: "1px solid red", width: "150px", borderRadius: "8px" }
      : { width: "150px" };
    const assetInputStyle = this.state.Notasset
      ? { border: "1px solid red", width: "150px", borderRadius: "8px" }
      : { width: "150px" };

    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_MILEAGE_REPORT_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >

                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>

                <Dropdown
                  menu={this.menuProps}
                  disabled={
                    this.mileageReportStore?.mileageReportStore?.length > 0
                      ? false
                      : true
                  }
                >
                  <Button className="exportDropdown"
                  >
                    <Space>
                      {this.context.translate("_EXPORT_")}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>

              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={22}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={this.handleChange}
                  allowClear={true}
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />
                {this.props.getUserData().isadmin === 1 && (
                  <DeviceGroupsForVehicles
                    vehicleStore={this.vehicleStore}
                    setLoadDta={() => this.setState({ loadData: 1 })}
                    resetVehicles={() =>
                      this.setState({
                        selectedVehicles: [],
                        selectAllVehicles: false,
                      })
                    }
                  />
                )}
                <Checkbox
                  checked={this.state.selectAllVehicles}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllVehicles: e.target.checked,
                    });
                    console.log(e.target.checked);
                    await this.handleAllSelectVehicles();
                  }}
                />
                {/* All */}
                {this.context.translate("_ALL_")}

                <Select
                  className="searchInput"
                  maxTagCount="responsive"
                  value={this.state.selectedVehicles}
                  onChange={(val) => {
                    this.setState({ selectedVehicles: val });
                    if (
                      this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                      val.length
                    ) {
                      this.setState({ selectAllVehicles: false });
                    } else {
                      this.setState({ selectAllVehicles: true });
                    }

                    if (val?.length > 1) {
                      console.log(val?.length > 1);
                      this.setState({ showAlertPopup: true });
                    }
                  }}
                  style={{ width: 150 }}
                  showSearch
                  status={this.state.Notasset ? "error" : false}
                  mode="multiple"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                  )}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                    return (
                      <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                    );
                  })}
                </Select>

                <Select
                  style={{
                    width: 130,
                  }}
                  className="searchInput"
                  value={this.state.filterValue ? this.state.filterValue : null}
                  placeholder={this.context.translate("_FILTER_TYPE_")}
                  optionFilterProp="children"
                  status={this.state.notFilter ? "error" : false}
                  onSelect={async (value) => {
                    await this.setState({
                      filterValue: value,
                    });
                  }}
                  options={[
                    {
                      value: 1,
                      label: "Cumulative Distance",
                    },
                    {
                      value: 2,
                      label: "Daily Distance",
                    },
                  ]}
                />

                <RangePicker
                  placeholder={["From Datetime", "To Datetime"]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 350, borderRadius: "25px" }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  disabledDate={(current) => {
                    return current && current > dayjs();
                  }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [dayjs().startOf("day"), dayjs()],
                  }}
                  status={this.state.Notdate ? "error" : false}
                  defaultValue={[dayjs().startOf("day"), dayjs()]}
                />
                <Input
                  // placeholder="Mileage"
                  className="searchInput"
                  placeholder={this.context.translate("_MILEAGE_")}
                  style={{ width: 80 }}
                  value={this.state.mileage}
                  onChange={(e) => this.setState({ mileage: e.target.value })}
                />
                <Input
                  // placeholder="Fuel Price"
                  className="searchInput"
                  placeholder={this.context.translate("_FUEL_PRICE_")}
                  style={{ width: 80 }}
                  value={this.state.fuelprice}
                  onChange={(e) => this.setState({ fuelprice: e.target.value })}
                />
                <Button
                  type="primary"
                  onClick={() => {
                    this.showData();
                    this.setState({ pageNo: 1 });
                  }}
                >
                  {/* Show */}
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={2}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.mileageReportStore?.mileageReportStore?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.ExportMenuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={300}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {console.log(this.newColumns, "Df")}
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            currentPage={this.state.pageNo}
            pageSize={this.state.pageSize}
            total={this.mileageReportStore?.total}
            columns={this.state.column}
            dataSource={this.mileageReportStore?.mileageReportStore}
            // loading={this.mileageReportStore?.loading}
            // onChange={this.handleTableChange}
            // pagination={{
            //   pageSize: this.state.pageSize,
            //   //  current:this.state.pageNo
            //   total: this.mileageReportStore?.total || 0

            // }}
            loading={this.mileageReportStore?.loading}
            onChange={this.handleTableChange}
            // showSizeChanger={false}
            // moreClass="gridNum"
            // scroll={{
            //   // y: this.state.clientHeight-240,
            //   x: 100,
            // }}
          />

          <Modal
            width={350}
            className="alert-model"
            title={
              <div>
                {" "}
                <i
                  style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                  class="bi bi-exclamation-triangle"
                ></i>{" "}
                {/* Alert */}
                {this.context.translate("_FLEET_ALERT_")}
              </div>
            }
            open={this.state.showMonthPopup}
            onOk={() => this.setState({ showMonthPopup: false })}
            onCancel={() => this.setState({ showMonthPopup: false })}
            footer={false}
          >
            {/* For Reports prior to 6 months please contact administrator */}
            {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
          </Modal>
        </div>
        {
          <div>
            <PythonMessageAlert
              ref={this.pythonMessageRef}
              message={this.state.reportmessage}
            />
          </div>
        }
      </>
    );
  }
}
MileageReportList.contextType = StoreContext;
export default observer(withRouter(MileageReportList));
